import { ProgressStepperStepDot } from './ProgressStepperStepDot';

// TODO: in v9, move styled() from ProgressStepperStepDot.jsx to here
export var StyledProgressStepperStepDot = ProgressStepperStepDot;